import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import ErrorMessage from './ErrorMessage';
import LoadingMessage from './Loading';
import { useAuthStore } from '../store/AuthContext';
import { StylesSwapHelper } from '../utils/StylesSwapHelper';
import { StorageHelper } from '../utils/StorageHelper';

type Props = {
  children?: React.ReactNode;
};
const Layout: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  const dataUser = useAuthStore();
  const isApp = dataUser.user.isApp === 'true';
  const isEcommerceBot = StorageHelper.isEcommerceBot();

  StylesSwapHelper.swapStyleIfApp(isApp || isEcommerceBot);

  useEffect(() => {
    if (location) {
      if (!location.pathname.includes('revista')) {
        sessionStorage.setItem('yearRevistas', '0');
        sessionStorage.setItem('revistaSelect', 'no-select');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>
      <Header />
      <ErrorMessage />
      <LoadingMessage />
      <main>{children}</main>
      <Footer />
    </>
  );
};
export default Layout;
